import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { take } from 'rxjs/operators'

@Component({
    templateUrl: './not-implemented.component.html',
})
export class NotImplementedComponent implements OnInit {
    path: string

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.data.pipe(take(1)).subscribe(data => {
            this.path = data.path
        })
    }
}
